import { jsx as _jsx } from "react/jsx-runtime";
import { useQueryClient } from '@tanstack/react-query';
import { useCallback, useMemo, useState } from 'react';
import { createPortal } from 'react-dom';
import { PtsDocumentModal } from '../../components/pts_document_modal';
import { invalidateSignedDocumentQueries } from '../../utils/invalidate_signed_document_queries';
export const usePtsDocumentAction = ({ apiClient, accountId, isNoPiiSite, isDocGenEconsentEnabled, participantId, getApiErrorMessage, canVoidDocument, onVoidDocument, canDownloadConsentPdf = true, }) => {
    const queryClient = useQueryClient();
    const [selectedDocument, setSelectedDocument] = useState(null);
    const isPtsInteractionEnabled = isDocGenEconsentEnabled;
    const openPtsDocument = useCallback((document) => {
        if (!isPtsInteractionEnabled) {
            return;
        }
        setSelectedDocument(document);
    }, [isPtsInteractionEnabled]);
    const closePtsDocument = useCallback(() => setSelectedDocument(null), []);
    const ptsDocumentModal = useMemo(() => isPtsInteractionEnabled && selectedDocument && apiClient && accountId
        ? createPortal(_jsx(PtsDocumentModal, { isOpen: true, onClose: closePtsDocument, signedDocId: selectedDocument._id, status: selectedDocument.ec__status, signatureDate: selectedDocument.ec__pts_signature_date_wallclock, finalDocumentUrl: selectedDocument.ec__final_document?.url, accountId: accountId, isNoPiiSite: isNoPiiSite, apiClient: apiClient, getApiErrorMessage: getApiErrorMessage, onComplete: () => {
                invalidateSignedDocumentQueries(queryClient, { participantId });
                closePtsDocument();
            }, canVoid: canVoidDocument?.(selectedDocument), onVoid: () => {
                closePtsDocument();
                onVoidDocument?.(selectedDocument);
            }, canDownloadConsentPdf: canDownloadConsentPdf }), document.body)
        : null, [
        accountId,
        apiClient,
        canVoidDocument,
        closePtsDocument,
        canDownloadConsentPdf,
        getApiErrorMessage,
        isNoPiiSite,
        isPtsInteractionEnabled,
        onVoidDocument,
        participantId,
        queryClient,
        selectedDocument,
    ]);
    return { isPtsInteractionEnabled, openPtsDocument, ptsDocumentModal };
};
